import { track } from '@vercel/analytics';
import { hasAnalyticsConsent } from './cookieConsent';

const MAX_PROPERTY_LENGTH = 255;

const clip = (value) => {
  const text = typeof value === 'string' ? value.trim() : '';
  if (!text) return 'unknown';
  return text.length > MAX_PROPERTY_LENGTH
    ? text.slice(0, MAX_PROPERTY_LENGTH)
    : text;
};

export const trackVideoClick = ({ title, carousel } = {}) => {
  if (!hasAnalyticsConsent()) return;

  try {
    track('Video Click', {
      title: clip(title),
      carousel: clip(carousel),
    });
  } catch {
  }
};
